/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import safeInclude from "./safeInclude";

const extractor = (string: string, flag: string) => {
  if (string.indexOf(flag) === -1) {
    // ------------------
    return "";
  }
  // ----------[target]--------
  const unfilteredTarget = string.slice(string.indexOf(flag) + flag.length); // [target]--------
  const filteredTarget = unfilteredTarget.slice(
    0,
    nextQueryMark(unfilteredTarget)
  ); // [target]
  return filteredTarget;
};

const nextQueryMark = (string: string) => {
  return safeInclude(string, "?") ? string.indexOf("?") : string.length;
};

const extractToken = (query: string) => {
  const tokenFlag = "lt=";
  const guestFlag = "&guest";
  const locationFlag = "?location=";
  const JWToken = extractor(query, tokenFlag);
  const isMobileGuest = safeInclude(query, guestFlag) ? "true" : ""; // This was done on a hurry. Refactor later.
  const location = extractor(query, locationFlag);
  return { JWToken, isMobileGuest, location };
};

export default extractToken;
